import { getMainApi, postMainApi } from "@Shared/@Utils/ajax";
export const runTheReport = async payload => {
  return postMainApi(payload, "/statistics");
};
export const getReportHistory = async pagination => {
  return getMainApi(pagination, "/statistics/history");
};
export const getReportFile = async reportId => {
  return getMainApi({}, `/statistics/history/${reportId}`);
};
export const getNrOfUnsyncedApplications = async payload => {
  return postMainApi(payload, "/statistics/unsynced-applications");
};